module.exports = __webpack_public_path__ + "static/media/github.3f42676e.png";